import styled from 'styled-components';

const SearchIconContainer = styled.i`
  padding-right: ${({ theme }) => theme.spacing(6)};
  line-height: 30px;
`;

export default SearchIconContainer;
